(() => {
  const doorLabels = {
    wood: 'Porte en bois',
    armored: 'Porte blindée',
    turkish: 'Porte turque blindée',
  };

  const spaceLabels = {
    home: 'Maison',
    apartment: 'Appartement',
    villa: 'Villa',
    airbnb: 'Location Airbnb',
    office: 'Bureau',
    commerce: 'Commerce',
    hotel: 'Hôtel ou riad'
  };

  const exposureLabels = {
    outdoor: 'Extérieur',
    indoor: 'Intérieur'
  };

  const exposureIcons = { outdoor: 'icon-sun', indoor: 'icon-shield' };
  const spaceIcons = {
    home: 'icon-qeydo-housing', apartment: 'icon-qeydo-apartment', villa: 'icon-qeydo-villa',
    airbnb: 'icon-qeydo-airbnb', office: 'icon-qeydo-office', commerce: 'icon-qeydo-commerce', hotel: 'icon-qeydo-hotel'
  };
  const featureLabels = {
    alarm: 'Alarme anti-effraction', doorbell: 'Sonnette intégrée',
    video: 'Vidéo en temps réel', motion: 'Détection de mouvement'
  };
  const featureIcons = {
    alarm: 'icon-shield', doorbell: 'icon-qeydo-phone-ring', video: 'icon-video', motion: 'icon-eye'
  };

  const splitValues = (value) => (value || '').split(',').map((item) => item.trim()).filter(Boolean);

  function initFinder(root) {
    if (!root || root.dataset.finderReady === 'true') return;
    root.dataset.finderReady = 'true';

    const steps = Array.from(root.querySelectorAll('[data-step]'));
    const intro = root.querySelector('[data-finder-intro]');
    const startButton = root.querySelector('[data-finder-start]');
    const nextButton = root.querySelector('[data-finder-next]');
    const backButton = root.querySelector('[data-finder-back]');
    const nextLabel = root.querySelector('[data-next-label]');
    const backLabel = root.querySelector('[data-back-label]');
    const progressLabel = root.querySelector('[data-progress-label]');
    const progressName = root.querySelector('[data-progress-name]');
    const progressSegments = Array.from(root.querySelectorAll('.qeydo-lock-finder__progress-track span'));
    const progress = root.querySelector('[data-finder-progress]');
    const stage = root.querySelector('.qeydo-lock-finder__stage');
    const navigation = root.querySelector('[data-finder-navigation]');
    const results = root.querySelector('[data-finder-results]');
    const resultGrid = root.querySelector('[data-result-grid]');
    const resultEmpty = root.querySelector('[data-result-empty]');
    const resultsHeading = root.querySelector('.qeydo-lock-finder__results-heading');
    const resultKicker = root.querySelector('[data-result-kicker]');
    const resultTitle = root.querySelector('[data-result-title]');
    const resultDescription = root.querySelector('[data-result-description]');
    const compatibilityHelp = root.querySelector('[data-open-compatibility-help]');
    const catalog = root.querySelector('[data-product-catalog]');
    const models = Array.from(catalog.querySelectorAll('[data-product-model]'));
    const advisor = root.querySelector('[data-advisor-step]');
    const advisorTitle = root.querySelector('[data-advisor-title]');
    const advisorDescription = root.querySelector('[data-advisor-description]');
    const contactOptions = root.querySelector('[data-contact-options]');
    const showContactButton = root.querySelector('[data-show-contact-options]');
    const directContactToggle = root.querySelector('[data-direct-contact-toggle]');
    const directContactOptions = root.querySelector('[data-direct-contact-options]');
    const openChatButtons = Array.from(root.querySelectorAll('[data-open-shopify-chat]'));
    const doorImages = {
      wood: root.dataset.doorImageWood,
      armored: root.dataset.doorImageArmored, turkish: root.dataset.doorImageTurkish,
    };
    let currentStep = 0;
    let showingResults = false;
    let showingAdvisor = false;
    let advisorFromResults = false;
    let advisorOriginStep = 0;
    let autoAdvanceTimer;
    let journeyStarted = false;

    const forceResultLayout = () => {
      if (!resultGrid) return;
      const desktopOrTablet = window.matchMedia('(min-width: 750px)').matches;
      resultGrid.style.setProperty('display', 'grid', 'important');
      resultGrid.style.setProperty('width', '100%', 'important');
      resultGrid.style.setProperty('max-width', 'none', 'important');
      resultGrid.style.setProperty(
        'grid-template-columns',
        desktopOrTablet ? 'repeat(3, minmax(0, 1fr))' : 'minmax(0, 1fr)',
        'important'
      );
      resultGrid.style.setProperty('column-gap', desktopOrTablet ? '3.2rem' : '0', 'important');
      resultGrid.style.setProperty('row-gap', desktopOrTablet ? '4.8rem' : '4rem', 'important');

      resultGrid.querySelectorAll('[data-product-model]').forEach((card) => {
        card.style.setProperty('width', '100%', 'important');
        card.style.setProperty('min-width', '0', 'important');
        card.style.setProperty('max-width', 'none', 'important');
      });

      resultGrid.querySelectorAll('[data-result-features] > li').forEach((row) => {
        row.style.setProperty('display', 'flex', 'important');
        row.style.setProperty('width', '100%', 'important');
        row.style.setProperty('min-height', '5.2rem', 'important');
        row.style.setProperty('flex-flow', 'row nowrap', 'important');
        row.style.setProperty('align-items', 'center', 'important');
        row.style.setProperty('justify-content', 'flex-start', 'important');
        row.style.setProperty('gap', '1.2rem', 'important');
        row.style.setProperty('padding', '1.2rem 0', 'important');
        row.style.setProperty('border-radius', '0', 'important');
        row.style.setProperty('background', 'transparent', 'important');
        row.style.setProperty('text-align', 'left', 'important');

        const rowIcon = row.querySelector('.icon');
        const rowLabel = row.querySelector('span');
        if (rowIcon) {
          rowIcon.style.setProperty('width', '2.8rem', 'important');
          rowIcon.style.setProperty('height', '2.8rem', 'important');
          rowIcon.style.setProperty('min-width', '2.8rem', 'important');
          rowIcon.style.setProperty('flex', '0 0 2.8rem', 'important');
          rowIcon.style.setProperty('margin', '0', 'important');
        }
        if (rowLabel) {
          rowLabel.style.setProperty('display', 'block', 'important');
          rowLabel.style.setProperty('width', 'auto', 'important');
          rowLabel.style.setProperty('flex', '1 1 auto', 'important');
          rowLabel.style.setProperty('margin', '0', 'important');
          rowLabel.style.setProperty('text-align', 'left', 'important');
        }
      });
    };

    const getSelected = (name) => {
      const inputs = Array.from(root.querySelectorAll(`input[name="${name}"], input[name="${name}[]"]:checked`));
      if (name === 'access' || name === 'feature') return inputs.filter((input) => input.checked).map((input) => input.value);
      const selected = inputs.find((input) => input.checked);
      return selected ? selected.value : '';
    };

    const stepIsValid = () => steps[currentStep].querySelectorAll('input:checked').length > 0;

    const updateNavigation = () => {
      if (showingAdvisor) {
        nextButton.hidden = true;
        backButton.hidden = false;
        backLabel.textContent = advisorFromResults ? 'Retour à ma sélection' : 'Retour au sélecteur';
        return;
      }
      nextButton.disabled = !stepIsValid();
      nextButton.hidden = showingResults;
      const advisorIsSelected = currentStep === steps.length - 1 && getSelected('access').includes('advisor');
      nextLabel.textContent = currentStep === steps.length - 1 && !advisorIsSelected ? 'Voir ma sélection' : 'Continuer';
      backButton.hidden = currentStep === 0 && !showingResults;
      backLabel.textContent = showingResults ? 'Modifier mes réponses' : 'Retour';
    };

    const updateProgress = (isResult = false) => {
      progressLabel.textContent = isResult ? 'Votre sélection' : `Étape ${currentStep + 1} sur ${steps.length}`;
      progressName.textContent = isResult ? 'Résultat' : steps[currentStep].dataset.stepName;
      progressSegments.forEach((segment, index) => segment.classList.toggle('is-active', isResult || index <= currentStep));
    };

    const focusHeading = (element) => {
      if (!element) return;
      window.requestAnimationFrame(() => element.focus({ preventScroll: true }));
    };

    const bringJourneyIntoView = () => {
      const progress = root.querySelector('[data-finder-progress]');
      if (!progress) return;
      window.requestAnimationFrame(() => {
        const rect = progress.getBoundingClientRect();
        if (rect.top < 16 || rect.top > window.innerHeight * 0.42) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          progress.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      });
    };

    const showStep = (index) => {
      if (intro) intro.hidden = true;
      if (progress) progress.hidden = false;
      if (stage) stage.hidden = false;
      if (navigation) navigation.hidden = false;
      showingResults = false;
      showingAdvisor = false;
      advisorFromResults = false;
      stage.classList.remove('is-empty-result');
      results.classList.remove('is-empty-result');
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      results.hidden = true;
      advisor.hidden = true;
      contactOptions.hidden = true;
      showContactButton.setAttribute('aria-expanded', 'false');
      nextButton.hidden = false;
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== currentStep;
        step.classList.toggle('is-active', stepIndex === currentStep);
      });
      updateProgress();
      updateNavigation();
      bringJourneyIntoView();
      focusHeading(steps[currentStep].querySelector('.qeydo-lock-finder__question'));
    };

    const showAdvisor = (mode = 'advisor', fromResults = false) => {
      advisorOriginStep = currentStep;
      showingResults = false;
      showingAdvisor = true;
      advisorFromResults = fromResults;
      stage.classList.remove('is-empty-result');
      results.classList.remove('is-empty-result');
      steps.forEach((step) => { step.hidden = true; });
      results.hidden = true;
      advisor.hidden = false;
      contactOptions.hidden = true;
      showContactButton.setAttribute('aria-expanded', 'false');
      progressLabel.textContent = 'Accompagnement';
      progressName.textContent = 'À votre écoute';
      progressSegments.forEach((segment, index) => segment.classList.toggle('is-active', index <= advisorOriginStep));
      const textMode = mode === 'unknown' ? 'unknownText' : 'defaultText';
      advisorTitle.textContent = advisorTitle.dataset[textMode];
      advisorDescription.textContent = advisorDescription.dataset[textMode];
      updateNavigation();
      bringJourneyIntoView();
      focusHeading(advisorTitle);
    };

    const getReasons = (model, answers) => {
      const reasons = [];
      const doors = splitValues(model.dataset.doors);
      const exposures = splitValues(model.dataset.exposures);
      const spaces = splitValues(model.dataset.spaces);
      if (answers.door !== 'unknown' && doors.includes(answers.door) && doorLabels[answers.door]) reasons.push({ kind: 'door', label: doorLabels[answers.door], image: doorImages[answers.door] });
      if (!['unsure', 'advisor'].includes(answers.exposure) && exposures.includes(answers.exposure) && exposureLabels[answers.exposure]) reasons.push({ kind: 'exposure', label: exposureLabels[answers.exposure], icon: exposureIcons[answers.exposure] });
      if (spaces.includes(answers.space) && spaceLabels[answers.space]) reasons.push({ kind: 'space', label: spaceLabels[answers.space], icon: spaceIcons[answers.space] });
      return reasons.slice(0, 3);
    };

    const scoreModel = (model, answers) => {
      const doors = splitValues(model.dataset.doors);
      const exposures = splitValues(model.dataset.exposures);
      const spaces = splitValues(model.dataset.spaces);
      const accesses = splitValues(model.dataset.access);
      const features = splitValues(model.dataset.features);
      if (root.dataset.hideUnavailable === 'true' && model.dataset.available !== 'true') return null;
      if (doors.length && !doors.includes(answers.door)) return null;
      if (!['unsure', 'advisor'].includes(answers.exposure) && exposures.length && !exposures.includes(answers.exposure)) return null;
      if (answers.access.some((value) => !accesses.includes(value))) return null;
      if (answers.feature.some((value) => !features.includes(value))) return null;

      let score = Number.parseInt(model.dataset.priority || '0', 10) || 0;
      score += doors.includes(answers.door) ? 60 : 20;
      if (!['unsure', 'advisor'].includes(answers.exposure) && exposures.includes(answers.exposure)) score += 30;
      if (spaces.includes(answers.space)) score += 22;
      answers.access.forEach((value) => { if (accesses.includes(value)) score += 9; });
      answers.feature.forEach((value) => { if (features.includes(value)) score += 12; });
      return score;
    };

    const renderResults = () => {
      const answers = {
        door: getSelected('door'),
        exposure: getSelected('exposure'),
        space: getSelected('space'),
        access: getSelected('access'),
        feature: getSelected('feature')
      };

      models.forEach((model) => {
        model.hidden = true;
        model.removeAttribute('data-result-rank');
        const reasonsList = model.querySelector('[data-result-reasons]');
        if (reasonsList) reasonsList.replaceChildren();
        const featuresList = model.querySelector('[data-result-features]');
        if (featuresList) featuresList.replaceChildren();
        catalog.appendChild(model);
      });

      const ranked = models.map((model) => ({
        model,
        score: scoreModel(model, answers),
        createdAt: Number.parseInt(model.dataset.createdAt || '0', 10) || 0
      }))
        .filter((item) => item.score !== null)
        .sort((a, b) => (b.createdAt - a.createdAt) || (b.score - a.score));

      resultGrid.replaceChildren();
      resultGrid.dataset.resultCount = String(ranked.length);
      const hasResults = ranked.length > 0;
      stage.classList.toggle('is-empty-result', !hasResults);
      results.classList.toggle('is-empty-result', !hasResults);
      if (resultsHeading) resultsHeading.hidden = hasResults;
      resultEmpty.hidden = hasResults;
      [resultKicker, resultTitle, resultDescription].forEach((element) => {
        if (!element) return;
        element.textContent = hasResults ? element.dataset.defaultText : element.dataset.emptyText;
      });

      ranked.forEach(({ model }, index) => {
        model.hidden = false;
        model.dataset.resultRank = String(index);
        const reasonsList = model.querySelector('[data-result-reasons]');
        getReasons(model, answers).forEach((reason) => {
          const item = document.createElement('li');
          item.dataset.selectionKind = reason.kind;
          const icon = reason.image ? document.createElement('img') : document.createElement('i');
          if (reason.image) {
            icon.className = 'qeydo-lock-finder__selection-image';
            icon.src = reason.image;
            icon.alt = '';
          } else {
            icon.className = `icon icon-pack ${reason.icon}`;
            icon.setAttribute('aria-hidden', 'true');
          }
          const label = document.createElement('span');
          label.textContent = reason.label;
          item.append(icon, label);
          reasonsList.appendChild(item);
        });
        const featuresList = model.querySelector('[data-result-features]');
        const availableFeatures = splitValues(model.dataset.features);
        const featuresSection = featuresList?.closest('.qeydo-lock-finder__selected-features');
        if (featuresSection) featuresSection.hidden = availableFeatures.length === 0;
        availableFeatures.forEach((value) => {
          if (!featureLabels[value]) return;
          const item = document.createElement('li');
          item.className = 'qeydo-lock-finder__feature-row';
          let icon;
          if (value === 'doorbell') {
            icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            icon.setAttribute('viewBox', '0 0 24 24');
            icon.setAttribute('fill', 'none');
            icon.innerHTML = '<path d="M6 16h12l-1.4-2.1V10a4.6 4.6 0 0 0-9.2 0v3.9L6 16Z"></path><path d="M10 19h4"></path><path d="M12 5V3"></path>';
          } else {
            icon = document.createElement('i');
            icon.className = `qeydo-lock-finder__feature-row-icon icon icon-pack ${featureIcons[value]}`;
          }
          icon.classList.add('qeydo-lock-finder__feature-row-icon', 'icon');
          icon.setAttribute('aria-hidden', 'true');
          const label = document.createElement('span');
          label.className = 'qeydo-lock-finder__feature-row-label';
          label.textContent = featureLabels[value];
          item.append(icon, label);
          featuresList.appendChild(item);
        });
        resultGrid.appendChild(model);
      });

      forceResultLayout();

      steps.forEach((step) => { step.hidden = true; });
      advisor.hidden = true;
      results.hidden = false;
      showingResults = true;
      showingAdvisor = false;
      updateProgress(true);
      updateNavigation();
      nextButton.hidden = true;
      bringJourneyIntoView();
      if (hasResults) {
        const firstResultAction = resultGrid.querySelector('a[href], button');
        if (firstResultAction) focusHeading(firstResultAction);
      } else {
        focusHeading(root.querySelector('.qeydo-lock-finder__result-title'));
      }
    };

    const advanceFromCurrentStep = () => {
      if (!stepIsValid()) return;
      const doorChoice = getSelected('door');
      const exposureChoice = getSelected('exposure');
      const accessChoices = getSelected('access');
      if (currentStep === 0 && (doorChoice === 'unknown' || doorChoice === 'advisor')) {
        showAdvisor(doorChoice);
        return;
      }
      if (currentStep === 1 && exposureChoice === 'advisor') {
        showAdvisor('advisor');
        return;
      }
      if (steps[currentStep].querySelector('input[name="access[]"]') && accessChoices.includes('advisor')) {
        showAdvisor('advisor');
        return;
      }
      if (currentStep < steps.length - 1) showStep(currentStep + 1);
      else renderResults();
    };

    root.addEventListener('change', (event) => {
      const input = event.target.closest('input');
      if (!input) return;
      journeyStarted = true;
      if (input.name === 'access[]') {
        const accessInputs = Array.from(root.querySelectorAll('input[name="access[]"]'));
        if (input.value === 'advisor' && input.checked) accessInputs.forEach((item) => { if (item !== input) item.checked = false; });
        else if (input.checked) {
          const advisor = accessInputs.find((item) => item.value === 'advisor');
          if (advisor) advisor.checked = false;
        }
      }
      updateNavigation();
      if (input.type === 'radio' && currentStep < steps.length - 1) {
        window.clearTimeout(autoAdvanceTimer);
        autoAdvanceTimer = window.setTimeout(advanceFromCurrentStep, 220);
      }
    });

    startButton?.addEventListener('click', () => {
      journeyStarted = true;
      showStep(0);
    });

    nextButton.addEventListener('click', advanceFromCurrentStep);

    backButton.addEventListener('click', () => {
      nextButton.hidden = false;
      if (showingAdvisor && advisorFromResults) renderResults();
      else if (showingAdvisor) showStep(advisorOriginStep);
      else if (showingResults) showStep(steps.length - 1);
      else showStep(currentStep - 1);
    });

    compatibilityHelp?.addEventListener('click', () => showAdvisor('advisor', true));

    showContactButton.addEventListener('click', () => {
      contactOptions.hidden = false;
      showContactButton.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => contactOptions.focus({ preventScroll: true }));
    });

    directContactToggle?.addEventListener('click', () => {
      const willOpen = directContactOptions.hidden;
      directContactOptions.hidden = !willOpen;
      directContactToggle.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) window.requestAnimationFrame(() => directContactOptions.focus({ preventScroll: true }));
    });

    const openShopifyChat = () => {
      const chatHost = document.querySelector('#ShopifyChat, #shopify-chat, shopify-chat, [data-shopify-chat]');
      const chatApi = window.ShopifyChat || window.Shopify?.chat;
      if (chatApi && typeof chatApi.open === 'function') {
        chatApi.open();
        return;
      }
      if (!chatHost) {
        window.location.href = root.querySelector('.qeydo-lock-finder__contact-card[href*="/pages/contact"]')?.href || '/pages/contact';
        return;
      }
      const shadowButton = chatHost.shadowRoot?.querySelector('button, [role="button"]');
      if (shadowButton) shadowButton.click();
      else if (typeof chatHost.click === 'function') chatHost.click();
      if (typeof chatHost.focus === 'function') chatHost.focus();
    };

    openChatButtons.forEach((button) => button.addEventListener('click', openShopifyChat));

    window.addEventListener('resize', forceResultLayout, { passive: true });

    root.querySelectorAll('[data-door-compatibility-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector('[data-qeydo-door-compatibility]');
        if (!target) return;
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        const title = target.querySelector('.door-compatibility__title');
        if (title) {
          title.setAttribute('tabindex', '-1');
          window.setTimeout(() => title.focus({ preventScroll: true }), reduceMotion ? 0 : 500);
        }
      });
    });

    updateNavigation();
  }

  const initAll = (scope = document) => scope.querySelectorAll('[data-lock-finder]').forEach(initFinder);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
